import React from 'react';
import { Switch, Route, BrowserRouter } from 'react-router-dom';

import SubscriptionPage from '../../containers/SubscriptionPage';
import HomePage from '../../containers/HomePage';
import ChargifyRedirect from '../../containers/ChargifyRedirect';
import ProductPage from '../../containers/ProductPage';
import InvitationPage from '../../containers/InvitationPage';
import UpdateSubscriptionPage from '../../containers/UpdateSubscriptionPage';

import BillingInfoPage from '../../components/billingInfo/BillingInfoPage';
import PageNotFound from '../../components/PageNotFound';
import SigninRedirect from '../../containers/SigninRedirect';

const Subscription = ({match}) => 
  <SubscriptionPage subscriptionId={match.params.subscriptionId} />

const SubscriptionEdit = ({match}) => 
  <UpdateSubscriptionPage subscriptionId={match.params.subscriptionId} />

const Product = ({match}) =>
  <ProductPage productId={match.params.productId} />

const Invitation = ({match}) =>
  <InvitationPage 
    invitationId={match.params.invitationId}
    invitationToken={match.params.invitationToken}
  />

const Routes = () => (
  <BrowserRouter>
    <Switch>
      <Route path='/subscriptions/:subscriptionId/update' component={SubscriptionEdit} />
      <Route path='/subscriptions/:subscriptionId' component={Subscription} />
      <Route path='/chargify-redirect' component={ChargifyRedirect} />
      <Route path='/billing-info' component={BillingInfoPage} />
      <Route path='/products/:productId' component={Product} />
      <Route path='/invitations/:invitationId/:invitationToken' component={Invitation} />
      <Route path='/signin-redirect' component={SigninRedirect} />
      <Route exact path='/' component={HomePage} />
      <Route component={PageNotFound} />
    </Switch>
  </BrowserRouter>
)

export default Routes;


// WEBPACK FOOTER //
// ./src/components/accounts/Routes.js